import { render, staticRenderFns } from "./row-alink.vue?vue&type=template&id=c6bd1e96&scoped=true"
import script from "./row-alink.vue?vue&type=script&lang=js"
export * from "./row-alink.vue?vue&type=script&lang=js"
import style0 from "./row-alink.vue?vue&type=style&index=0&id=c6bd1e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bd1e96",
  null
  
)

export default component.exports